var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.17944V10.1794M22.5 5.17944V10.1794M6.25 15.1794H28.75M8.75 7.67944H26.25C27.6307 7.67944 28.75 8.79873 28.75 10.1794V27.6794C28.75 29.0602 27.6307 30.1794 26.25 30.1794H8.75C7.36929 30.1794 6.25 29.0602 6.25 27.6794V10.1794C6.25 8.79873 7.36929 7.67944 8.75 7.67944Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.06fbe85d15fbf9fa0463ec2e6d445c79.svg";
export { ForwardRef as ReactComponent };